/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import Datatable from 'shared/datatable';
import { secret_key, taxexemptionpending } from 'shared/settings/apiconfig';
import Notes from './Notes';
import { connect } from 'react-redux';
import axios from 'axios';
import { getSellerHeaders, getSellerUrl } from 'shared/http';

// style imports
import './TaxExemptionPendingList.scss';
import store from 'features/store';


/**
 * this page is used to list buyers
 * 
 * @param props
 * 
 * @returns html code to render the pending tax exemption list
 * 
**/

class TaxExemptionPendingList extends Component {
    config;
    buyerAccessToken;
    buyerHeaders;
    initialSearchState;
    filterSearch;
    id;
    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.id = '';
        this.userLocations = this.props?.user?.locationid.filter(x => !!x);
        /* initial search state */
        this.initialSearchState = {
            firstname: { field: 'firstname', value: '', op: 'LIKE', join: 'AND' },
            lastname: { field: 'lastname', value: '', op: 'LIKE', join: 'AND' },
            nickname: { field: 'nickname', value: '', op: '=', join: 'AND' },
            email: { field: 'email', value: '', op: 'LIKE', join: 'AND' },
            mobile: { field: 'mobile', value: '', op: 'LIKE', join: 'AND' },
            suspended: { field: 'suspended', value: '', op: '=', join: 'AND' },
            isDeleted: { field: 'isDeleted', value: 0, op: '=', join: 'AND' },
            inactive: { field: 'active', value: '', op: '=', join: 'AND' },
            starttime: { field: 'fromdate', value: '', op: '>=', join: 'AND' },
            endtime: { field: 'todate', value: '', op: '<=', join: 'AND' },
            locationid: { field: 'locationid', value: "", op: '=', join: 'AND' },
        }
        this.state = {
            buyerAccessToken: '',
            buyerHeaders: {},
            search: this.initialSearchState,
            searchData: true,
            tableData: [],
            // notesModal: false,
            issearch: false,
            buyerDetails: {},
            buyerToken: null,
            pageLoading: true
        }

        this.config = {
            name: 'buyer',
            url: taxexemptionpending,
            params: {},
            columns: [
                { name: 'Name', property: 'lastname', sort: true, width: '280px', columnType: 'custom', customColumn: this.customName },
                { name: 'User Name', property: 'nickname', sort: true, width: '130px' },
                { name: 'Email', property: 'email', sort: true, width: '130px' },
                { name: 'Phone', property: 'mobile', sort: true, width: '130px', sortType: 'num' },
                { name: 'Status', property: 'active', sort: true, sortType: 'num', width: '130px', columnType: 'custom', customColumn: this.customStatus },
                { name: 'Tax Exemption Submission Date', property: 'taxsubmissiondate', sort: true, width: '150px', columnType: 'custom', customColumn: this.taxExemptdate },
                { name: '', property: 'purchasedate', sort: false, width: '160px', columnType: 'custom', customColumn: this.approveButton },
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['accordion'], customHeader: <></>, width: '10px',
                    actionEvents: { edit: (row, state) => { row['headers'] = this.buyerHeaders; this.navigateToTaxExemption(row, state); }, notes: (id) => { this.viewNotes(id) } }, accordion: this.accordionValue
                }
            ],
            sort: [{ field: 'taxsubmissiondate', direction: 'desc' }],
            pagination: true,
            defaultFilter: [
                {
                    "field": "locationid",
                    "value": this.userLocations,
                    "op": "IN",
                    "join": "AND"
                },   
                {
                    "field": "active",
                    "join": "AND",
                    "op": "=",
                    "value": 1
                },
                {
                    "field":"shipping",
                    "value":1,
                    "op":"=",
                    "join":"AND"
                }  
            ],
            field: ["id", "firstname", "lastname", "email", "locationid", "nickname", "mobile", "active", "modifieddate", "purchasedate", "city", "address1", "address2", "state", "zipcode", "taxsubmissiondate"],
            buyerUrl: { token: null }
        };
        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search && !this.props.location.state.prevPath) {
            let tempSearch = { ...this.initialSearchState };
            const search = [...props.location.state.datatable.search];

            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                if ( temp['field'] === 'fromdate' ||  temp['field'] === 'todate') {
                    temp['value'] = new Date(temp['value']);
                }
                if (temp.field === 'fromdate' || temp['field'] === 'todate') {
                    if (temp.op === '>=') {
                      tempSearch['starttime'] = { ...temp, field: 'fromdate' };
                    } else if (temp.op === '<=') {
                      tempSearch['endtime'] = { ...temp, field: 'todate' };
                    }
                  } else {
                    tempSearch[temp.field] = temp;
                  }
                tempSearch[temp['field']] = temp;
            });

            this.state['search'] = tempSearch;
            this.state['issearch'] = Boolean(search.length);
            this.state['searchData'] = true;
        }
    }

    componentDidMount() {
       // store.dispatch({ type: 'PENDING_TAX_EXEMPTION_LIST', payload: 0 });
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
        this.getSecretKey();
    }
    /* componentDidUpdate(prevProps, prevState) {
        if (prevProps.refreshPendingList !== this.props.refreshPendingList) {   
             
            this.setState({
                PendingCount: this.props.taxExemptionPendingList
            })     
        }
      } */

    navigateToTaxExemption = (value) => {
       
        let row = { firstname: value.firstname, lastname: value.lastname, id: value.id, isFromPendingList: true };
        this.props.history.push(`/buyer/edit/${value['id']}/taxexemption`, row);
    }

    getSecretKey() {
        axios.get(getSellerUrl(`${secret_key}`), getSellerHeaders()).then(response => {
            if (response.data.status.toLowerCase() === 'success') {
                this.config.buyerUrl.token = response.data.accessToken;
                this.setState({
                    buyerToken: response.data.accessToken,
                    pageLoading: false
                });
            }
        }).catch(error => {
            this.setState({
                pageLoading: false
            });
        });
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }


    customName = (values) => <span>{`${values['lastname']} ${values['firstname']}`}</span>;

    approveButton = (value) => {
        return (
            <div>
                <Button onClick={() => this.navigateToTaxExemption(value)} variant="secondary">Review</Button>
            </div>
        )
    }
    taxExemptdate = (value) => {
        if (value['taxsubmissiondate']) {
            return `${moment.utc(value['taxsubmissiondate']).local().format('MM/DD/YYYY')}`;
        }
        return '- - -';
    };
    customDate = (value) => {
        if (value['purchasedate']) {
            return `${moment.utc(value['purchasedate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    customStatus = (values) => {
        if (values['active'])
            return <span>Active</span>;
        else
            return <span>Inactive</span>;
    }
    /* called when accordion clicked */
    accordionValue = (tr) => {
        let row = JSON.stringify(tr)
        row = row.replace(/""/g, '"- - - "')
        row = JSON.parse(row)
        return (
            <div style={{ padding: "1% 2%" }}>
                {row && Object.keys(row).length ?
                    <div className="d-flex" style={{ justifyContent: "space-evenly" }}>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Address 1</div>
                            <div>{row['address1']}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Address 2</div>
                            <div>{row['address2'] != null ? row['address2'] : '- - -'}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">City</div>
                            <div>{row['city']}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">State</div>
                            <div>{row['state']}</div>
                        </div>
                        <div style={{ margin: "0 5%" }}>
                            <div className="text-accordion-header">Zip Code</div>
                            <div>{row['zipcode']}</div>
                        </div>
                    </div>
                    : ''}
            </div>
        );
    }
    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        if (event.target.name === 'inactive' || event.target.name === 'suspended') {
            eventValue = event.target.checked;
        }
        if (event.target.name === 'mobile') {
            if (isNaN(eventValue))
                eventValue = '';
        }

        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: eventValue
                }
            }
        }, () => {
            if (event.target.value === '')
                this.checkSearch();
        });
    }

    /* called when clear all in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: false,
            issearch: false,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* called when search button clicked */
    enableSearch = () => {
        let search = {};
        search = {
            firstname: { ...this.state.search.firstname, value: this.state.search.firstname.value ? this.state.search.firstname.value + '*' : '' },
            lastname: { ...this.state.search.lastname, value: this.state.search.lastname.value ?  this.state.search.lastname.value + '*' : '' },
            email: { ...this.state.search.email, value: this.state.search.email.value ? '*' + this.state.search.email.value + '*' : '' },
            mobile: { ...this.state.search.mobile, value: this.state.search.mobile.value ? '*' + this.state.search.mobile.value + '*' : '' },
            nickname: { ...this.state.search.nickname, value: this.state.search.nickname.value ? this.state.search.nickname.value  : '' },
            starttime: { ...this.state.search.starttime, value: this.state.search.starttime.value ? moment(new Date(this.state.search.starttime.value)).startOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            endtime: { ...this.state.search.endtime, value: this.state.search.endtime.value ? moment(new Date(this.state.search.endtime.value)).endOf('day').format("YYYY-MM-DD HH:mm:ss") : '' },
            suspended: { ...this.state.search.suspended },
            isDeleted: { ...this.state.search.isDeleted, value: 0 },
            inactive: { ...this.state.search.inactive, value: this.state.search.inactive.value ? 0 : 1 }
        }
        this.setState({
            filterSearch: search,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* check enable search and clear all */
    checkSearch = () => {
        let isenable = false;
        let issearchData = this.state.searchData;
        for (let control of Object.keys(this.state.search)) {
            if (this.state.search[control].value) {
                isenable = true;
                break;
            }
        }
        this.setState({
            ...this.state,
            search: isenable ? this.state.search : this.initialSearchState,
            searchData: isenable ? this.state.searchData : false,
            issearch: isenable
        }, () => {
            if (!isenable && issearchData)
                this.dataTable.current.searchData();
        });
    }

    updateTableData = (event) => {
        this.setState({
            ...this.state,
            tableData: event
        },()=>{
            let buyerId = event?.data?.filter(function(e){return e.id}).map(function(e){
                return e.id
                })
            store.dispatch({ type: 'PENDING_TAX_EXEMPTION_LIST', payload: event?.data?.length });
        });
    }

    /* called when note clicked */
    viewNotes = (id) => {
        if (window.location.href.endsWith("/buyer")) {
            const data = this.state.tableData.data.filter(x => x.id === id);
            // let data = buyerMockData.filter(x => x.id === id);
            if (data.length > 0) {
                data[0]['title'] = data[0]['lastname'] + ',' + data[0]['firstname'];
                data[0]['headers'] = this.buyerHeaders;
                this.setState({
                    ...this.state,
                    modal: true,
                    buyerDetails: data[0]
                });
                this.id = id;
            }
        }
    }

    /* called when save or note closed */
    hideNotes = () => {
        this.setState({
            ...this.state,
            modal: false
        })
    }

    // handle enter key search
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.enableSearch()
        }
    }

    /* set date for date input change */
    setDate = (control, date) => {
        this.setState({
            ...this.state,
            issearch: true,
            search: {
                ...this.state.search,
                [control]: {
                    ...this.state.search[control],
                    value: date
                },
            }
        });
    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    render() {

        return (
            <div className={`h-100`}>
                {
                    this.state.pageLoading ?
                        <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                        </div> :

                        <div className="tax-emption-pending-list">
                            <div className="d-flex flex-column justify-content-center align-items-center bg-search" style={{ padding: "1% 3%" }}>
                                <Row className="d-flex flex-row w-100">
                                    <Col className="d-flex flex-column text-secondary">
                                        <small>First Name</small>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="firstname" value={this.state.search.firstname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col className="d-flex flex-column text-secondary">
                                        <small>Last Name</small>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="lastname" value={this.state.search.lastname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col className="d-flex flex-column text-secondary">
                                        <small>User Name</small>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="nickname" value={this.state.search.nickname.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col className="d-flex flex-column text-secondary">
                                        <small>Email Address</small>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="email" value={this.state.search.email.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                    <Col className="d-flex flex-column text-secondary">
                                        <small>Phone Number</small>
                                        <Form.Control onKeyDown={this._handleKeyDown} type="text" name="mobile" value={this.state.search.mobile.value} onChange={(event) => this.searchInputChange(event)} />
                                    </Col>
                                </Row>
                                <Row className="d-flex flex-row w-100">
                                    <Col  className="d-flex flex-column text-secondary">
                                        <small>Location *</small>
                                        <Form.Control as="select" name="locationid" value={this.state.search.locationid.value} onKeyDown={this._handleKeyDown} onChange={(event) => this.searchInputChange(event)}>
                                            <option value="" disabled>Select location</option>
                                            {this.state.locations.map((loc, index) =>
                                                <option key={index} value={loc.id}>{loc.title}</option>
                                            )}
                                        </Form.Control>
                                    </Col>
                                    <Col className="d-flex flex-column text-secondary">
                                        <small>Created Date From</small>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.start.state.open && e.preventDefault()}>
                                                <DatePicker ref={r => this.start = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.starttime.value} selected={this.state.search.starttime.value} onChange={date => { this.setDate('starttime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "48%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col className="d-flex flex-column text-secondary">
                                        <small>Created Date To</small>
                                        <div>
                                            <label style={{ width: "100%" }} onClick={e => this.end.state.open && e.preventDefault()}>
                                                <DatePicker minDate={this.state.search.starttime.value ? this.state.search.starttime.value : ''} ref={r => this.end = r} className="datePicker" dateFormat="MM/dd/yyyy" value={this.state.search.endtime.value} selected={this.state.search.endtime.value} onChange={date => { this.setDate('endtime', date) }} onChangeRaw={this.handleDateChangeRaw} peekNextMonth showMonthDropdown showYearDropdown placeholderText="MM/DD/YYYY" dropdownMode="select" />
                                                <i style={{ position: "absolute", top: "48%", right: "12%", color: "#00263E" }} className="fa fa-calendar" aria-hidden="true"></i>
                                            </label>
                                        </div>
                                    </Col>
                                    <Col className="d-flex flex-column text-secondary">

                                    </Col>
                                    <Col className="d-flex flex-column text-secondary">

                                    </Col>
                                    {/* <Col className="d-flex flex-column text-secondary">

                                    </Col>
                                    <Col className="d-flex flex-column text-secondary">

                                    </Col> */}
                                    {/* <Col className="offset-5"></Col> */}

                                </Row>
                                {/* <Row className="d-flex flex-row p-2 w-100">
                        <Col className="d-flex flex-column text-secondary mx-2">
                            <small>Item SKU</small>
                            <Form.Control type="text" name="itemSKU" value={this.state.search.itemSKU.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary mx-2">
                            <small>Item Title</small>
                            <Form.Control type="text" name="itemtitle" value={this.state.search.itemtitle.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary mx-2">
                            <small>Location</small>
                            <Form.Control type="text" name="location" value={this.state.search.location.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary mx-2">
                            <small>Sale</small>
                            <Form.Control type="text" name="saletitle" value={this.state.search.saletitle.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                        <Col className="d-flex flex-column text-secondary mx-2">
                            <small>Category</small>
                            <Form.Control type="text" name="category" value={this.state.search.category.value} onChange={(event) => this.searchInputChange(event)} />
                        </Col>
                    </Row> */}
                                <Row className="d-flex w-100">
                                    <Col md={6}></Col>
                                    <Col md={6}>
                                        <div className="buttonClass">
                                            <Button variant="clear-button" style={{ boxShadow: "none" }} onClick={() => this.resetState()}>Clear All</Button>
                                            <Button style={{ marginLeft: "2%" }} variant="seller-search" onClick={() => this.enableSearch()}>Search</Button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            {this.state.modal ?
                                <Notes modal={this.state.modal} id={this.id} name='buyer' data={this.props} hideNotes={this.hideNotes} /> : ''
                            }
                            <div className="buyer-table">
                                {/* need to add props, as it provides the previous state of datatable */}
                                <Datatable {...this.props} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.filterSearch }, searchData: this.state.searchData } : null} ref={this.dataTable} onDataUpdate={this.updateTableData} />
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(TaxExemptionPendingList);